import { render, staticRenderFns } from "./RelatoriosSubmenu.vue?vue&type=template&id=3943ce5a&"
import script from "./RelatoriosSubmenu.vue?vue&type=script&lang=js&"
export * from "./RelatoriosSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports